import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { environment } from "src/environments/environment";

export interface Product {
  data: any;
  id: number;
  titulo: string;
  autor: number;
  autor_id: number;
  edicion: string;
  ano_edicion: number;
  formato: string;
  isbn: string;
  descripcion: string;
  ilustrador: string;
  editorial: string;
  id_categoria: number;
  cantidad: number;
  precio: number;
  precio2: number;
  descuento: number;
  tipo_formato: string;
  anchura: number;
  altura: number;
  profundidad: number;
  peso: number;
  costo_envio: number;
  costo_manual: string;
  estado: string;
}

@Injectable({
  providedIn: "root",
})
export class ProductosService {
  //private url:string = 'http://localhost:8888/testproducts/src/api/productos.php';
  //private url2:string = 'http://192.168.0.8:8888/testproducts/src/api/productos.php';

  private apiToken =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";

  //private urlyii2:string = 'http://localhost:8888/cronoadminv3/productos/apiproductos?token=';
  private urlyii2: string = environment.urlLibros + "?token=";

  private url: string = environment.apiUrl2;

  constructor(private http: HttpClient) {}
  getProducts() {
    //'productos/apiproductos?token=' + apiToken + ''
    //return this.http.get(environment.apiUrl+'productos');
    return this.http.get(environment.apiUrl + "productos");
  }

  getAll() {
    return this.http.get<Array<Product>>(
      this.urlyii2 + this.apiToken + "&opcion=1"
    );
  }
  get(id: number) {
    return this.http.get<Product>(
      this.urlyii2 + this.apiToken + "&opcion=2&id=" + id
    );
  }

  getByAutor(idt, id) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];
    postData.push({ auth_key: idt });
    postData.push({ id: id });
    return this.http.post<Product>(
      this.urlyii2 + this.apiToken + "&opcion=5",
      JSON.stringify(postData)
    );
    /********************** */
  }
  getByCollection(idt, id) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];
    postData.push({ auth_key: idt });
    postData.push({ id: id });
    return this.http.post<Product>(
      this.urlyii2 + this.apiToken + "&opcion=6",
      JSON.stringify(postData)
    );
  }

  filtroPrecios(r1, r2, e1, e2) {
    // comentar
    return this.http.get<Product>(
      this.urlyii2 +
        this.apiToken +
        "&opcion=4&r1=" +
        r1 +
        "&r2=" +
        r2 +
        "&e1=" +
        e1 +
        "&e2=" +
        e2
    );
  }

  getByIds(ids) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    /********************** */
    let postData = [];
    ids.forEach((element) => {
      postData.push({ id: element });
    });
    return this.http.post<any>(
      this.urlyii2 + this.apiToken + "&opcion=3",
      JSON.stringify(postData)
    );
    /********************** */
  }

  getLicense(auth_key, id) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];
    let formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id", id);
    return this.http.post<any>(
      `${environment.host}/usuario/apiperfil?opcion=18`,
      formData
    );
    /********************** */
  }

  getPlanes(auth_key, id) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];
    let formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id", id);
    return this.http.post<any>(
      `${environment.host}/planes-suscripcion/api-index-active`,
      formData
    );
    /********************** */
  }

  getPrecioEnvio(auth_key, id, id_direccion) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];
    let formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id", id);
    formData.append("id_direccion", id_direccion);
    return this.http.post<any>(
      `${environment.host}/precios-envio-admin/api-envio`,
      formData
    );
    /********************** */
  }
  /*create(product: Product){
    return this.http.get<Product>(this.url+'productos.php?opcion=3');
  }
  update(product: Product, id:number){
    return this.http.get<Product>(this.url+'productos.php?opcion=4&id='+id);
  }
  delete(id:number){
    return this.http.get<Product>(this.url+'productos.php?opcion=5&id='+id);
  }*/

  getRelatedBooks(id_category, id_libro, page, pageSize) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];
    let formData = new FormData();
    formData.append("id_category", id_category);
    formData.append("id_libro", id_libro);
    return this.http.post<Product>(
      `${environment.host}/productos/apiproductos2?page=${page}&pageSize=${pageSize}`,
      formData
    );
  }

  getProductosFilter(dataFilter: any, page = 1, pageSize = 24) {
    console.log(
      "🚀 ~ ProductosService ~ getProductosFilter ~ dataFilter:",
      dataFilter
    );
    let params = new HttpParams()
      .set("page", page.toString())
      .set("pageSize", pageSize.toString());

    // Agregar valores simples
    if (dataFilter.name) params = params.set("name", dataFilter.name);
    if (dataFilter.e1) params = params.set("e1", dataFilter.e1);
    if (dataFilter.e2) params = params.set("e2", dataFilter.e2);
    if (dataFilter.p1) params = params.set("r1", dataFilter.p1);
    if (dataFilter.p2) params = params.set("r2", dataFilter.p2);
    if (dataFilter.orden) params = params.set("orden", dataFilter.orden);

    // Agregar arrays como collection[]=2&collection[]=3
    if (Array.isArray(dataFilter.coleccion)) {
      dataFilter.coleccion.forEach((val: any) => {
        params = params.append("coleccion[]", val);
      });
    }

    if (Array.isArray(dataFilter.autor)) {
      dataFilter.autor.forEach((val: any) => {
        params = params.append("autor[]", val);
      });
    }
    return this.http.get<any>(`${this.urlyii2}${this.apiToken}&opcion=4`, {
      params,
      responseType: "json",
    });
  }

  redimirCodigo(auth_key, id, codigo) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];
    let formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id", id);
    formData.append("codigo", codigo);
    return this.http.post<any>(
      `${environment.host}/usuario/apiperfil?opcion=23`,
      formData
    );
  }

  cancelarSuscripcion(auth_key, id, plan, reason) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    let postData = [];
    let formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id", id);
    formData.append("id_suscripcion", plan.suscripcion_epayco);
    formData.append("motivo", reason);
    return this.http.post<any>(
      `${environment.host}/compras/cancelar-suscripcion`,
      formData
    );
  }
}
